import { render } from "./UserRolesModal.vue?vue&type=template&id=55e34b86"
import script from "./UserRolesModal.vue?vue&type=script&lang=js"
export * from "./UserRolesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__